module.exports = __webpack_public_path__ + "img/engineeringCases5.8e523691.png";